/* eslint-disable react/require-default-props */
import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { ReactComponent as CalendarSVG } from './assets/calendar.svg';
import { ReactComponent as TimeSVG } from './assets/time.svg';
import useStyles from './styles';

interface EventCardTitleProps {
  date: string;
  duration?: string | number;
  name: string;
}

const EventCardTitle = ({ date, duration, name }: EventCardTitleProps) => {
  const classes = useStyles();
  return (
    <Box>
      <Typography className={classes.dateLabel} variant="body2">
        <Box className={classes.calendarIcon}>
          <CalendarSVG />
        </Box>
        {date}

        {duration && (
          <>
            <Box className={classes.timeIcon}>
              <TimeSVG />
            </Box>
            {duration} mins
          </>
        )}
      </Typography>

      <Typography component="span" variant="h4" className={classes.name}>
        {name}
      </Typography>
    </Box>
  );
};

export default EventCardTitle;
